<template>
    <div id='step2'>
        <div class="tips">
            <StepTips title="核對清楚地址資料" text="一旦提交並不能再作出更改，需要重新預約。"/>
        </div>
        <span class="hasInvoice" @click="ChangehasInvoice(true)" v-if="!hasInvoice">我有發票和包裝單?</span>
        <span class="hasInvoice" @click="ChangehasInvoice(false)" v-if="hasInvoice">手動加入物品</span>
        <div class="main" v-if="!hasInvoice">
            <el-form :model="orderDetail" :rules="orderDetailFormRule" ref="orderDetailForm" >
                <div class="shipmentType">
                    <div class="h">
                        物品申報
                    
                    </div>
                    <el-form-item prop="typeId">
                        <el-radio-group v-model="orderDetail.isreturn">
                          <el-radio :label="0">自用</el-radio>
                          <el-radio :label="1">商品或退貨</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div class="goodsList">
                    <div class="tipsborder" v-if="goodsList.length==0">
                        
                    </div>
                    <div class="good" v-for="(item,index) in goodsList" :key="item.frontID">
                        <div class="left">
                            <div class="number">
                                {{index+1}}
                            </div>
                            <div class="img">
                                <img :src="`${item.image}`" alt="暂无图片">
                            </div>
                            <div class="nameAndNum">
                                <div class="name">
                                {{item.name}}
                                </div>
                                <div class="bum">
                                    x {{item.count}}
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="currency">
                                <p class="moneyType">{{item.moneyType}}</p>
                                <p class="money">
                                    {{item.price*item.count}}
                                </p>
                            </div>
                            <div class="options">
                                <div class="delete" @click="deleteGood(item.frontID)">
                                    <span class="el-icon-error"></span>
                                </div>
                                <div class="edit" @click="handlerEditGood(item)">
                                    <span class="el-icon-edit-outline"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="itemType">
                    <div class="h">
                        物品種類
                    </div>
                    <el-row type="flex">
                        <el-col :span="colSpan">
                            <el-select @change="handleItemOneLeavelChange" v-model="curLeavenTypeId" placeholder="请选择">
                                <el-option
                                  v-for="item in itemOneLeavel"
                                  :key="item.id"
                                  :label="item[_i18n.locale == 'en' ? 'nameEn' : 'name']"
                                  :value="item.id"
                                  @click="setImage('a')">
                                  <div @click="setImage(item.image)">
                                      <span>{{item[_i18n.locale == 'en' ? 'nameEn' : 'name']}}</span>
                                  </div> 
                                </el-option>
                              </el-select>
                        </el-col>
                        <el-col :span="colSpan">
                            <el-select v-model="orderDetail.typeId" placeholder="请选择">
                                <el-option
                                  v-for="item in itemTowLeavel"
                                  :key="item.id"
                                  :label="item[_i18n.locale == 'en' ? 'nameEn' : 'name']"
                                  :value="item.id">
                                  <div @click="setImage(item.image)">
                                    <span>{{item[_i18n.locale == 'en' ? 'nameEn' : 'name']}}</span>
                                </div>
                                </el-option>
                              </el-select>
                        </el-col>
                    </el-row>
                </div>
                <div class="itemEnglishContent">
                    <div class="t">
                        <p class="h">物品申報英文内容</p>
                        <p class="p">
                            確保你的寄件並無任何<span class="tightStop">禁運物品清單</span>，不確定請向我們查詢，違者會被罰款。
                        </p>
                    </div>
                    <div class="b">
                        <el-form-item prop="name">
                            <el-input v-model="orderDetail.name" placeholder="例如 : Face Mask"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="addEnglishContent">
                    <div class="t">
                        <p class="h">英文補充資料 (選填)</p>
                    </div>
                    <div class="b">
                        <el-form-item prop="addEnglishContent">
                            <el-input v-model="orderDetail.addEnglishContent" placeholder="例如 : Cotton"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="totalNumberAndtotalHKD">
                    <div class="left">
                        <div class="t">
                            <p class="h">總數量</p>
                            <p class="tips">* 總數量最少为1</p>
                        </div>
                        <div class="b">
                            <el-form-item prop="count">
                                <el-input v-model.number="orderDetail.count"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="right">
                        <div class="t">
                            <p class="h">總值 (UShasInvoice)</p>
                            <p class="tips">* 最少USD为1</p>
                        </div>
                        <div class="b">
                            <el-form-item  prop="price">
                                <el-input  v-model.number="orderDetail.price"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="slections">
                    <div class="isDanger">
                        <p class="h">這是危險品/含電池或液體？<span class="el-icon-question" @click="infoAlertShow=true"></span></p>
                        <div class="radio">
                            <div class="true">
                               <div class="check" :class="orderDetail.isDanger == 1?'checkActive':''" @click="changeIsDanger(1)">
                                    <span class="el-icon-check"></span>
                               </div>
                                <span>是</span>
                            </div>
                            <div class="false">
                                <div class="check"  :class="orderDetail.isDanger == 0?'checkActive':''" @click="changeIsDanger(0)">
                                    <span class="el-icon-check"></span>
                                </div>
                                <span>否</span>
                            </div>
                        </div>
                    </div>
                    <div class="isSafe">
                        <p class="h">您需要貨運保險嗎？</p>
                        <div class="radio">
                            <div class="true">
                               <div class="check" :class="orderDetail.isSafe == 1?'checkActive':''" @click="changeisSafe(1)">
                                    <span class="el-icon-check"></span>
                               </div>
                                <span>是</span>
                            </div>
                            <div class="false">
                                <div class="check"  :class="orderDetail.isSafe == 0?'checkActive':''" @click="changeisSafe(0)">
                                    <span class="el-icon-check"></span>
                                </div>
                                <span>否</span>
                            </div>
                        </div>
                    </div>
                    <div class="paymentDuty">
                        <p class="h">支付關稅和增值稅</p>
                        <div class="radio">
                            <div class="true">
                               <div class="check" :class="orderDetail.paymentDuty == 1?'checkActive':''" @click="changePaymentDuty(1)">
                                    <span class="el-icon-check"></span>
                               </div>
                                <span>發貨人</span>
                            </div>
                            <div class="false">
                                <div class="check"  :class="orderDetail.paymentDuty == 0?'checkActive':''" @click="changePaymentDuty(0)">
                                    <span class="el-icon-check"></span>
                                </div>
                                <span>收貨人</span>
                            </div>
                        </div>
                        <p class="tips">* Goods2GO將會與您聯系已安排關稅和增值稅。</p>
                    </div>
                </div>
            </el-form>
            <div class="add">
                <div class="c" @click="addItemType">
                    <span class="el-icon-circle-plus icon"></span>
                    <span>增加种类</span>
                </div>
            </div>
        </div>
        <div class="invoiceForm" v-if="hasInvoice">
            <!-- <el-input placeholder="發票/包裝單" v-model="invoice"></el-input> -->
            <el-upload
                class="upload-demo"
                drag
                :action="$baseURL + 'app/v2/upload/pdf'"
                multiple
                :headers="headers"
                :before-upload="beforeUpload"
                :on-success="onsuccess"
                :before-remove='beforeremove'
                :file-list="$store.state.orderVo.order.detailedPdf">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/PDf/xlsx文件</div>
            </el-upload>
        </div>
        <div class="nextBtn">
            <optionsButton title="下一步" :callback="next"/>
        </div>

        <!-- 付税提示框 -->
        <TaxAlert :alertShow="alertShow" title="重要" text="您選擇了由託運人支付的稅和增值税。預訂後,我們會盡快與您
以徵稅和增值稅。您的訂單物將“待處理”中,直至提供完善及
        清晰的貨物信息。" info="信息:進口税和増值税可由收貨人支付。變乎所有跨越國際握
        界的貨物均由進口國政府進行税和税收評估。海關官員根據貨
        運標上提供的信息、商業發票以及其他相文件對税和税收
        進行評估。)
        " :callback="tax"/>

        <!-- 信息提示框 -->
        <InfoAlert :alertShow="infoAlertShow" title="資訊" :callback="()=>{infoAlertShow=false}"/>
        <!-- 修改物品对话框 -->
<!-- 修改参数对话框 -->
<el-dialog
:title="'修改物品参数(' + curEditGood.addEnglishContent + ')'"
:visible.sync="showEditDiglog"
width="50%"
:close-on-click-modal="false"
>
<el-form :model="goodForm" :rules="goodFormFormRule" ref="goodFormForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="数量" prop="count">
        <el-input v-model="goodForm.count" type="number"></el-input>
    </el-form-item>
    <el-form-item label="總值 (USD)" prop="price">
        <el-input v-model="goodForm.price" type="number"></el-input>
    </el-form-item>
</el-form>
<span slot="footer" class="dialog-footer">
    <el-button @click="showEditDiglog = false">取 消</el-button>
    <el-button type="primary" @click="editGood">确 定</el-button>
</span>
</el-dialog>
    </div>
</template>

<script>
import StepTips from '@/components/StepTips.vue'
import optionsButton from '@/components/optionButton'
import TaxAlert from '@/components/TaxAlert'
import {mapState,mapMutations,mapActions} from 'vuex'
import InfoAlert from '@/components/InfoAlert'
import {nanoid} from 'nanoid'
export default {
    name:'Step2',
    components:{
        StepTips,
        optionsButton,
        TaxAlert,
        InfoAlert
    },
    data(){
        let validatePass = (rule, value, callback) => {
            if (Number.isInteger(Number(value)) && Number(value) > 0) {
                callback();
            } else {
                callback(new Error('請輸入大於0的整數'));
            }
        };
        return {
            // 当前表单每行占的宽度
            colSpan:11,
            // 物品表单规则
           orderDetailFormRule:{
                price:[
                    {required:true,message:'* 必须填写',tirgger:'blur'}
                ],
                typeName:[
                    {required:true,message:'* 必须填写',tirgger:'blur'}
                ],
                name:[
                    {required:true,message:'* 必须填写',tirgger:'blur'}
                ],
                count:[
                    {required:true,validator: validatePass,tirgger:'blur'},
                    {validator: validatePass},
                ],
                price:[
                    {required:true,validator: validatePass,tirgger:'blur'},
                    {validator: validatePass},
                ],
            },
            // 物品类别一级菜单
            itemOneLeavel:[],
            // 物品类别二级菜单
            itemTowLeavel:[],
            // 当前选中的以及物品类别Id
            curLeavenTypeId:'',
            // 货物表单
            orderDetail:{
                // 数量
                count: 0,
                id: 0,
                // 物品总值
                money: 0,
                // 前端标识ID
                frontID: '0',
                // 货币类型编号
                moneyType: "USD",
                // 货品名称
                name: "",
                orderId: 0,
                price: 0,
                // 货物类型ID
                typeId: "",
                // 是否属于退货
                isreturn:0,
                typeName: "",
                // 英文内容
                addEnglishContent:'',
                isDanger:0,
                // 是否是安全物品
                isSafe:0,
                // 是否收件人付税
                paymentDuty:0,
                // 图片链接
                image: '',
            },
            // 控制赋税提示框是否展示
            alertShow:false,
            // 控制信息提示框是否展示
            infoAlertShow:false,
            // 修改物品表单
            goodForm: {
                count: 0,
                price: 0
            },
            // 物品
            goodFormFormRule: {
                count: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: validatePass,
                        message: '請輸入物品數量'
                    }
                ],
                price: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: validatePass,
                        message: '請輸入物品價格'
                    }
                ]
            },
            // 是否展示修改物品对话框
            showEditDiglog: false,
            // 当前操作修改的物品
            curEditGood: {},
            // 是否使用發票/包裝單报关
            hasInvoice: false,
            // 發票/包裝單
            invoice: '',
            // 文件上传头部
            headers: {
                "X-User": window.sessionStorage.getItem('token')
            },
            // 当前上传的文件
            curFile: {}
        }
    },
    methods: {
        ...mapMutations(["UPDATEITEMTYPE","CHANGESTEP","ADDGOODTYPE"]),
        ...mapActions(['deleteGood']),
        // 获取一级物品类别
        async getItemOneType(){
            let res = await this.$http.post('app/data/getSort')
            if(!res.data.success) return
            this.itemOneLeavel = res.data.data
            console.log(res.data, "一级物品分类")
        },
        // 获取二级物品类别
        async getItemTowType(fid){
            let res = await this.$http.post(`app/data/getSort?fid=${fid}`)
            if(!res.data.success) return
            this.itemTowLeavel = res.data.data
        },
        // 监听用户选择一级菜单
        handleItemOneLeavelChange(value){
            this.getItemTowType(value)
        },
        // 监听用户点击是否是危险品
        changeIsDanger(type){
            this.orderDetail.isDanger = type
        },
        // 监听用户点击是否是保险
        changeisSafe(type){
            this.orderDetail.isSafe = type
        },
        // 监听用户点击是付税人
        changePaymentDuty(type){
            if(type) this.alertShow = true
            this.orderDetail.paymentDuty = type
        },
        // 监听用户点击添加种类
        addItemType(){
            this.orderDetail.frontID = nanoid()

            // 判断用户是否选择物品种类
            if(this.orderDetail.typeId=='')return this.$message.error('请选择物品分类')

            this.$refs.orderDetailForm.validate(async valid=>{
                if(!valid) return this.$message.error("请填写完整信息")
                this.ADDGOODTYPE(JSON.parse(JSON.stringify(this.orderDetail)))
                this.$refs.orderDetailForm.resetFields()
                this.curLeavenTypeId = ''
                this.orderDetail.image = ''
                this.$message.success("添加种类成功")
            })
        },
        // 监听用户点击下一步
        async next(){
            if(this.hasInvoice){
                if(this.$store.state.orderVo.order.detailedPdf.length <= 0){
                    this.$message.error('請先上傳文件')
                    return
                }
                this.CHANGESTEP(3)
                this.$router.push(`step${3}`)
                return
            }
            if(this.goodsList.length<=0) return this.$message.error('请添加商品种类')
            this.CHANGESTEP(3)
            this.$router.push(`step${3}`)
        },
        // 赋税人弹窗回调
        tax(valid){
            if(!valid) this.orderDetail.paymentDuty = 0
            this.alertShow = false
        },
        // 设置物品展示图片
        setImage(image){
            console.log(image)
            if(image != null || image + '' != 'null'){
                this.orderDetail.image = `http://goods2go.com.hk/goods2go-user/img/${image}`
            }
        },
        // 监听用户点击修改物品
        handlerEditGood(item){
            console.log(item)
            this.curEditGood = item
            this.showEditDiglog = true
            this.goodForm.price = item.price
            this.goodForm.count = item.count
        },
        // 修改物品
        editGood(){
            this.$refs.goodFormForm.validate(async valid => {
                if(!valid) return

                
                this.$store.dispatch('editGood', {
                    id: this.curEditGood.frontID,
                    count: this.goodForm.count,
                    price: this.goodForm.price
                })
                
                this.showEditDiglog = false
                this.$refs.goodFormForm.resetFields()
            })
        },
        // 监听用户点击切换是否使用小票报关
        ChangehasInvoice(boolean){
            this.hasInvoice = boolean
        },
        // 上传文件前的钩子
        beforeUpload(file){
            let arr = file.name.split('.')
            let type = arr[arr.length-1]
            console.log(type)
            if(type == 'pdf' || type == 'jpg' || type == 'jpeg' || type == 'png' || 'xlsx'){
                this.curFile = file
                return true
            }else{
                this.$message.error('請上傳正確格式的文件')
                return false
            }
        },
        // 上传文件成功的钩子
        onsuccess(res){
            console.log(res)
            if(res.success){
                this.$store.commit('SETdetailedPdf', {
                    uid: this.curFile.uid,
                    name: this.curFile.name,
                    url: res.data
                })
                this.$message.success(res.message)
            }else{
                this.$message.error(res.message)
            }
        },
        // 删除文件前的钩子
        beforeremove(file, fileList){
            fileList.forEach((element, index) => {
                if(element.uid == file.uid){
                    this.$store.commit('DELETEdetailedPdf', index)
                }
            });
        }
    },
    computed:{
        ...mapState({
            // 报关表单,
            goodsList:state => state.orderVo.orderDetail,
            curStep:state => state.curStep
        })
    },
    // 生命周期==>创建完成时
    created() {
        this.getItemOneType()
    },
}
</script>

<style lang="less">
#step2{
    .hasInvoice{
        display: inline-block;
        margin-top: 20px;
        color: @colorMain;
        font-size: 16px;
        &:hover{
            cursor: pointer;
            opacity: .8;
        }
    }
    .invoiceForm{
        margin-top: 30px;
    }
    .main{
        .h{
            font-weight: 550;
            font-size:17px;
            margin-top:50px;
            margin-bottom:10px;
        }
        .shipmentType{
            .el-radio__label{
                font-weight: 550;
                font-size: 16px;
            }
        }
        .goodsList{
            .good{
                display: flex;
                justify-content:space-between ;
                padding: 35px 0;
                border-bottom:2px solid #d4d4d4;
                .left{
                    width: 20%;
                    display: flex;
                    align-items: center;
                    justify-content:space-between ;
                    .number{
                        width: 40px;
                        height: 40px;
                        color:@colorMain;
                        text-align:center;
                        border:2px solid @colorMain;
                        line-height: 35px;
                        border-radius:50%;
                    }
                    .nameAndNum{
                        .name{
                            font-weight: 600;
                            font-size:18px;
                            margin-bottom:15px;
                        }
                        .num{
                            font-weight: 600;
                            font-size:18px;
                        }
                    }
                    .img{
                        width: 50px;
                        height: 50px;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .nameAndNum{
                        text-align: center;
                    }
                }
                .right{
                    width: 20%;
                    display: flex;
                    justify-content:space-between;
                    align-items: center;
                    .currency{
                        display: flex;
                        .moneyType{
                            font-weight: 550;
                            margin-right: 10px;
                            font-size: 17px;
                        }
                        .money{
                            font-weight: 550;
                            font-size: 17px;
                        }
                    }
                    .options{
                        display: flex;
                        align-items: center;
                        .delete,.edit{
                            font-size: 30px;
                            color:@colorMain;
                            margin-left:10px;
                            &:hover{
                                cursor: pointer;
                                opacity: .8;
                            }
                        }
                        .delete{
                            span{
                                color: #F7320F;
                            }
                        }
                    }
                }
            }
            .tipsborder{
                padding-bottom: 10px;
                border-bottom:2px solid #d4d4d4;
            }
        }
        .itemType{
            .el-row{
                flex-wrap: wrap;
                justify-content:space-between;
                .el-select{
                    width: 100%;
                    margin-top: 20px;
                    .shadowSelect();
                    .el-input__inner{
                        font-weight: 550;
                        font-size: 17px;
                        color:#000;
                    }
                }
            }
        }
        .itemEnglishContent{
            .t{
                .p{
                    font-weight: 540;
                    margin-top: 15px;
                    span{
                        display: inline-block;
                        margin: 0 5px ;
                        color: @colorMain;
                        border-bottom: 2px solid #cdc3d9;
                        padding-bottom: 5px;
                        &:hover{
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .totalNumberAndtotalHKD{
            display: flex;
            justify-content: space-between;
            .right,.left{
                width: 47%;
                .t{
                    display: flex;
                    margin-top: 50px;
                    .h{
                        margin: 0px;
                        margin-right:15px;
                        font-size:17px;
                    }
                    .tips{
                        display: flex;
                        color: @colorMain;
                        align-items: flex-end;
                    }
                }
            }
        }
        .slections{
            .isDanger,.isSafe,.paymentDuty{
                display: flex;
                margin-top:30px;
                .h{
                    margin: 0;
                    width: 280px;
                    span{
                        color: @colorMain;
                        font-size:20px;
                        cursor: pointer;
                    }
                }
                .radio{
                    display: flex;
                    .true,.false{
                        display: flex;
                        align-items: center;
                        margin:0 10px;
                        font-weight: 550;
                        .check{
                            display: flex;
                            width: 25px;
                            height: 25px;
                            border:1px solid #ccc;
                            border-radius:50%;
                            margin-right:10px;
                            align-items: center;
                            justify-content: center;
                            &:hover{
                                cursor: pointer;
                                opacity: .8;
                            }
                            span{
                                display: none;
                            }
                        }
                        .check.checkActive{
                            background-color: @colorMain;
                            border:1px solid @colorMain;
                            color: #fff;
                            span{
                                display:block;
                            }
                        }
                    }
                }
            }
            .paymentDuty{
                display: block;
                .h{
                    margin: 30px 0;
                }
                .radio{
                    margin-left: -12px;
                }
                .tips{
                    margin-top: 30px;
                    color: @colorMain;
                    font-weight: 540;
                    font-size: 16px;
                }
            }
        }
        .el-form{
            .el-form-item__content .el-input .el-input__inner{
                margin-top: 20px;
                border-radius:10px;
                border-color:#cbcbcb;
            }
        }
    }
    .add{
        text-align: center;
        margin-top: 50px;
        .c{
            width: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin:0 auto;
            &:hover{
                cursor: pointer;
                opacity: .8;
            }
        }
        span{
            color: @colorMain;
            font-size:17px;
            font-weight: 550;
        }
        .icon{
            font-size: 30px;
        }
    }
    .nextBtn{
        margin-top: 50px;
        width: 100%;
        button{
            width: 100%;
        }
    }
}
</style>